import React from 'react'

export const IconAdd = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill='currentColor' {...props}>
        <path fillRule="evenodd" d="M480 1117c-7.74 0-14-6.27-14-14s6.26-14 14-14c7.73 0 14 6.27 14 14s-6.27 14-14 14v0Zm0-30c-8.84 0-16 7.16-16 16s7.16 16 16 16c8.83 0 16-7.16 16-16s-7.17-16-16-16v0Zm6 15h-5v-5c0-.55-.45-1-1-1 -.56 0-1 .45-1 1v5h-5c-.56 0-1 .45-1 1s.44 1 1 1h5v5c0 .55.44 1 1 1 .55 0 1-.45 1-1v-5h5c.55 0 1-.45 1-1s-.45-1-1-1v0Z" transform="translate(-464-1087)"></path>
    </svg>
  )
}
